"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorefrontAddCheckoutLineItems = exports.useStorefrontCheckoutHeavy = exports.useStorefrontCheckoutLight = exports.useClearStorefrontCheckoutId = exports.useStorefrontCheckoutId = void 0;
const Sentry = __importStar(require("@sentry/react"));
const useLocalStorage_1 = __importDefault(require("react-use/lib/useLocalStorage"));
const useLiveLocalStorage_1 = __importDefault(require("../../lib/hooks/useLiveLocalStorage"));
const client_1 = require("@apollo/client");
const aws_auth_1 = require("@tbl/aws-auth");
const MapmakerApi_1 = require("../MapmakerApi");
(0, client_1.gql) `
  fragment StorefrontCheckoutLight on StorefrontCheckout {
    id
    completedAt
    lineItems(first: 100) {
      edges {
        node {
          id
          quantity
        }
      }
    }
  }

  query storefrontGetCheckoutLight($checkoutId: ID!) {
    storefrontCheckout: storefrontNode(id: $checkoutId) {
      id
      ... on StorefrontCheckout {
        ...StorefrontCheckoutLight
      }
    }
  }

  mutation storefrontCreateCheckout($input: StorefrontCheckoutCreateInput!) {
    storefrontCheckoutCreate(input: $input) {
      checkout {
        ...StorefrontCheckoutHeavy
      }
    }
  }

  mutation storefrontAddCheckoutLineItems(
    $checkoutId: ID!
    $lineItems: [StorefrontCheckoutLineItemInput!]!
  ) {
    storefrontCheckoutLineItemsAdd(
      checkoutId: $checkoutId
      lineItems: $lineItems
    ) {
      checkout {
        ...StorefrontCheckoutHeavy
      }
    }
  }
`;
const STOREFRONT_CHECKOUT_ID_KEY = "mapmaker.shopify.checkoutId";
// These were used until Feb. 2022, they can be safely removed in 2023.
const STOREFRONT_CHECKOUT_ID_KEY_PM = "pm.shopify.checkoutId";
const STOREFRONT_CHECKOUT_ID_KEY_TBL = "tbl.shopify.checkoutId";
/**
 * A very simple local storage value, but some extra logic to deal with merging TBL and PM
 * functionality.
 */
function useStorefrontCheckoutId() {
    var _a;
    const [pmCheckoutId, , clearPmCheckoutId] = (0, useLocalStorage_1.default)(STOREFRONT_CHECKOUT_ID_KEY_PM);
    const [tblCheckoutId, , clearTblCheckoutId] = (0, useLocalStorage_1.default)(STOREFRONT_CHECKOUT_ID_KEY_TBL);
    const [checkoutId, setCheckoutId] = (0, useLiveLocalStorage_1.default)(STOREFRONT_CHECKOUT_ID_KEY);
    if (pmCheckoutId) {
        clearPmCheckoutId();
        setCheckoutId(pmCheckoutId);
    }
    if (tblCheckoutId) {
        clearTblCheckoutId();
        setCheckoutId(tblCheckoutId);
    }
    return (_a = checkoutId !== null && checkoutId !== void 0 ? checkoutId : pmCheckoutId) !== null && _a !== void 0 ? _a : tblCheckoutId;
}
exports.useStorefrontCheckoutId = useStorefrontCheckoutId;
function useClearStorefrontCheckoutId() {
    const [, , clearCheckoutId] = (0, useLiveLocalStorage_1.default)(STOREFRONT_CHECKOUT_ID_KEY);
    return clearCheckoutId;
}
exports.useClearStorefrontCheckoutId = useClearStorefrontCheckoutId;
function useStorefrontCheckoutIdFull() {
    return (0, useLiveLocalStorage_1.default)(STOREFRONT_CHECKOUT_ID_KEY);
}
function useStorefrontCheckoutLight(queryOptions) {
    var _a, _b;
    const checkoutId = useStorefrontCheckoutId();
    const clearCheckout = useClearStorefrontCheckoutId();
    const result = (0, MapmakerApi_1.useStorefrontGetCheckoutLightQuery)(Object.assign(Object.assign({}, queryOptions), { skip: !checkoutId, variables: {
            checkoutId,
        }, onCompleted: result => {
            if (!result.storefrontCheckout ||
                !!result.storefrontCheckout["completedAt"]) {
                clearCheckout();
            }
        } }));
    const checkout = (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.storefrontCheckout) !== null && _b !== void 0 ? _b : undefined;
    return Object.assign({ checkout }, result);
}
exports.useStorefrontCheckoutLight = useStorefrontCheckoutLight;
function useStorefrontCheckoutHeavy(queryOptions) {
    var _a, _b;
    const checkoutId = useStorefrontCheckoutId();
    const clearCheckout = useClearStorefrontCheckoutId();
    const result = (0, MapmakerApi_1.useStorefrontGetCheckoutHeavyQuery)(Object.assign(Object.assign({}, queryOptions), { skip: !checkoutId, variables: {
            checkoutId,
        }, onCompleted: result => {
            var _a;
            const checkout = (_a = result.storefrontCheckout) !== null && _a !== void 0 ? _a : undefined;
            if (!checkout || !!checkout.completedAt) {
                clearCheckout();
            }
        } }));
    const checkout = (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.storefrontCheckout) !== null && _b !== void 0 ? _b : undefined;
    if (checkout === null || checkout === void 0 ? void 0 : checkout.lineItems.edges.some(edge => !edge.node.variant)) {
        // Old item was in cart.
        clearCheckout();
    }
    return Object.assign({ checkout }, result);
}
exports.useStorefrontCheckoutHeavy = useStorefrontCheckoutHeavy;
function useStorefrontAddCheckoutLineItems() {
    const { user } = (0, aws_auth_1.useAuthContext)();
    const [checkoutId, setCheckoutId] = useStorefrontCheckoutIdFull();
    // Used when we need to create the checkout.
    const [createCheckoutMutation, createCheckoutStatus,] = (0, MapmakerApi_1.useStorefrontCreateCheckoutMutation)({
        variables: {
            input: {
                email: user === null || user === void 0 ? void 0 : user.email,
            },
        },
    });
    // Used once we have a checkout.
    const [addCheckoutLineItemsMutation, addCheckoutLineItemsStatus,] = (0, MapmakerApi_1.useStorefrontAddCheckoutLineItemsMutation)();
    const createCheckout = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        if (checkoutId) {
            return checkoutId;
        }
        const result = yield createCheckoutMutation();
        const newCheckout = (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.storefrontCheckoutCreate) === null || _b === void 0 ? void 0 : _b.checkout;
        if (newCheckout) {
            setCheckoutId(newCheckout.id);
            return newCheckout.id;
        }
        else {
            Sentry.captureException("Error creating checkout.", {
                extra: {
                    storefrontApiResult: result.data,
                    storefrontApiErrors: result.errors,
                },
            });
            throw new Error("Error communicating with shop. Refresh the page or contact us if the problem persists.");
        }
    });
    // The method exposed to consumers, accepts line items and adds them to the cart, handling
    // creation if necessary.
    const addMethod = (lineItems) => __awaiter(this, void 0, void 0, function* () {
        const validCheckoutId = checkoutId !== null && checkoutId !== void 0 ? checkoutId : (yield createCheckout());
        return yield addCheckoutLineItemsMutation({
            variables: {
                checkoutId: validCheckoutId,
                lineItems,
            },
        });
    });
    return [
        addMethod,
        Object.assign(Object.assign({}, addCheckoutLineItemsStatus), { loading: createCheckoutStatus.loading || addCheckoutLineItemsStatus.loading, error: createCheckoutStatus.error || addCheckoutLineItemsStatus.error, called: createCheckoutStatus.called || addCheckoutLineItemsStatus.called }),
    ];
}
exports.useStorefrontAddCheckoutLineItems = useStorefrontAddCheckoutLineItems;
//# sourceMappingURL=data:application/json;base64,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